// Vendor
import { createPinia } from 'pinia';
// Plugins
import { createAPI, useAPI } from './plugins/api';
import { usePersistedState } from './plugins/persist';
import { useStoreByName } from './plugins/storeByName';
// Globals
import { ENDPOINTS } from './global';
const BUNDLE_NAME = '🍍 NVS Pinia Collection';
const usePiniaCollection = (options) => {
    const { api: apiOptions, namespace = 'nvs', persist } = options || {};
    const { baseURL = ENDPOINTS.API_BASE_URL, endpoints: customEndpoints, locale, onSessionExpired, } = apiOptions || {};
    const pinia = createPinia();
    const api = createAPI({
        baseURL,
        locale,
        onSessionExpired,
    });
    pinia.use(useAPI({
        api,
        endpoints: Object.assign(Object.assign({}, ENDPOINTS), customEndpoints),
    }));
    pinia.use(useStoreByName);
    if (persist) {
        pinia.use(usePersistedState(Object.assign(Object.assign({}, (typeof persist === 'object' ? persist : {})), { namespace })));
    }
    return pinia;
};
// Auth
export * from './auth/module';
// Nav
export * from './nav/module';
// Sylius
export * from './sylius/shop/order';
export * from './sylius/shop/taxon/_bundle';
// Plugins
export * from './plugins/_bundle';
// Global exports
export * from './global';
export { useContextStore } from './context';
export { BUNDLE_NAME, usePiniaCollection };
//# sourceMappingURL=index.js.map